// src/components/common/Loader.jsx
import React from "react";

const Loader = ({ overlay = false }) => {
  const inner = (
    <div className="flex gap-2 items-center justify-center">
      <div className="w-5 h-5 bg-[#d991c2] rounded-full animate-bounce"></div>
      <div className="w-5 h-5 bg-[#9869b8] rounded-full animate-bounce [animation-delay:0.1s]"></div>
      <div className="w-5 h-5 bg-[#6756cc] rounded-full animate-bounce [animation-delay:0.2s]"></div>
    </div>
  );

  if (overlay) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        {inner}
      </div>
    );
  }
  return inner;
};

export default Loader;
